export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-plan/+page.svelte";